/* eslint-disable max-len */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './WMICPaymentHistoryElement.metadata.json5';

import styles from './WMICPaymentHistoryElement.module.scss';
import { DateUtil } from 'wmic-portals-utils-js';
import { IntlContext } from '@jutro/legacy/locale';


const WMICPaymentHistoryElement = (props) => {
    const { data: elementData } = props;

    const intl = useContext(IntlContext);

    const paymentDate = DateUtil.formatDateIntl(elementData.receivedDate, intl);
    const paymentMethod = elementData.paymentMethod;
    const paymentAmount = elementData.amount;
    const paymentCurrencyAmount = elementData.currencyAmount;
    const policyNumber = elementData.policyNumber;

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrides = {
        paymentDate: {
            content: paymentDate
        },
        paymentMethod: {
            content: paymentMethod
        },
        paymentAmount: {
            value: paymentCurrencyAmount,
            showFractions: true
        },
        paymentHistorySrOnly: {
            content: "A payment of $" + paymentAmount + "  was made on "+ paymentDate + ", account reference "+ paymentMethod + ". Policy #" + policyNumber 
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            overrideProps={overrides}
            model={elementData}
        />
    );
};

WMICPaymentHistoryElement.propTypes = {
    data: PropTypes.shape({})
};

WMICPaymentHistoryElement.defaultProps = {
    data: {}
};

export default WMICPaymentHistoryElement;
